import { useLazyQuery } from '@apollo/client';
import { Box, Button, Typography } from '@material-ui/core';
import { useReactToPrint } from 'react-to-print';
import { useRef, useState } from 'react';
import { updateDocNumbers } from '../../common';
import useEmployees from '../../hooks/useEmployees';
import AdvanceReportPrint from '../../print/AdvanceReportPrint';
import FilterSelectCkeckBox from '../../Shared/FilterSelectCkeckBox';
import getEmployeeAdvance from '../../graphql/query/getEmployeeAdvance';

const getStartOfDay = (value: any) => {
  const dt = new Date(value);
  dt.setHours(0, 0, 0, 0);
  return dt;
};

const getEndOfDay = (value: any) => {
  const dt = new Date(value);
  dt.setHours(23, 59, 59, 999);
  return dt;
};

export default function AdvanceReportActions({
  isRTL,
  words,
  start,
  end,
  company,
}: any) {
  const { activeemployees } = useEmployees();
  const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
  const [reportRows, setReportRows] = useState<any[]>([]);
  const [reportEmployee, setReportEmployee] = useState<any>(null);

  const [loadEmployeeAdvance] = useLazyQuery(getEmployeeAdvance, {
    fetchPolicy: 'network-only',
  });

  const reportComponentRef: any = useRef();
  const handleReportPrint = useReactToPrint({
    content: () => reportComponentRef.current,
    documentTitle: isRTL ? 'تقرير السلف' : 'Employee Advances Report',
    removeAfterPrint: true,
  });

  const loadAndPrint = async (onlySelectedEmployee: boolean) => {
    if (!start || !end) return;
    if (onlySelectedEmployee && !selectedEmployee?._id) return;

    const variables: any = {
      start: getStartOfDay(start),
      end: getEndOfDay(end),
    };

    if (onlySelectedEmployee) {
      variables.employeeId = selectedEmployee._id;
      setReportEmployee(selectedEmployee);
    } else {
      setReportEmployee(null);
    }

    const res: any = await loadEmployeeAdvance({ variables });
    const data = res?.data?.getEmployeeAdvance?.data || [];
    setReportRows(updateDocNumbers(data));

    setTimeout(() => {
      handleReportPrint();
    }, 200);
  };

  const printData = {
    rows: reportRows,
    isRTL,
    start,
    end,
    employee: reportEmployee,
  };

  return (
    <>
      <Box
        style={{
          position: 'absolute',
          top: 8,
          left: isRTL ? 220 : undefined,
          right: isRTL ? undefined : 220,
          display: 'flex',
          gap: 8,
          alignItems: 'center',
          zIndex: 120,
        }}
      >
        <FilterSelectCkeckBox
          options={activeemployees}
          value={selectedEmployee}
          setValue={setSelectedEmployee}
          words={words}
          isRTL={isRTL}
          name="employee"
          nomulti
          width={220}
        />

        <Button
          onClick={() => loadAndPrint(true)}
          variant="contained"
          color="secondary"
          disabled={!selectedEmployee || !start || !end}
          style={{ height: 35 }}
        >
          <Typography style={{ fontSize: 12 }}>
            {isRTL ? 'طباعة موظف' : 'Print Employee'}
          </Typography>
        </Button>

        <Button
          onClick={() => loadAndPrint(false)}
          variant="contained"
          color="primary"
          disabled={!start || !end}
          style={{ height: 35 }}
        >
          <Typography style={{ fontSize: 12 }}>
            {isRTL ? 'طباعة كل السلف' : 'Print All Advances'}
          </Typography>
        </Button>
      </Box>

      <div style={{ display: 'none' }}>
        <AdvanceReportPrint
          company={company}
          printData={printData}
          ref={reportComponentRef}
        />
      </div>
    </>
  );
}
